import React from "react";
import styled from "@emotion/styled";
import { useSecurityImages } from "@hooks/useSecurityImages";
import { Symbol } from "./Symbol";

export const SymbolListContainer = styled.div`
  box-shadow: ${({ theme }) => theme.shadows[2]};
  border: 1px solid ${({ theme }) => theme.palette.border.secondary};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  margin-top: 5px;
  max-height: 400px;
  overflow-y: auto;
`;

export interface Props {
  symbols: SymbolWithQuote[];
  handleClick: (symbol: SymbolWithQuote) => void;
  shouldShowQuote?: boolean;
}

export const SymbolList = ({
  symbols,
  handleClick,
  shouldShowQuote,
}: Props) => {
  const logos = useSecurityImages(
    symbols.map((symbol) => ({
      hasValidIsin: true,
      type: symbol.quoteProvider === "currency" ? "81_fcurr" : "11_stock",
      isin: symbol.isin || symbol.quote?.tickerSymbol,
      ticker_symbol: symbol.quote?.tickerSymbol,
      quoteProvider: symbol.quoteProvider,
    }))
  );

  return (
    <SymbolListContainer className="symbol-results-list">
      {symbols.map((symbol, index) => {
        return (
          <Symbol
            key={`symbol-${index}`}
            name={symbol.name || "N/A"}
            isin={symbol.isin}
            image={
              logos[symbol.isin || ""] ||
              logos[symbol?.quote?.tickerSymbol || ""]
            }
            typeName={symbol.literalType || "N/A"}
            stockExchangeName={symbol.quote?.stockExchangeName || "N/A"}
            shouldShowQuote={shouldShowQuote}
            quote={symbol.quote?.last ? symbol.quote.last : symbol.quote?.bid}
            currency={symbol.quote?.currency}
            handleClick={() => handleClick(symbol)}
            testid={`symbol-${index}`}
          />
        );
      })}
    </SymbolListContainer>
  );
};
